<template>
  <div class=" tailor">
    <b-navbar class="navbar navbar-dark sticky-top" style="background-color: #563d7c;">
      <a class="navbar-brand" href="#" style="font-size: 1.04em;">Sensor Data <i class="fa fa-rss"></i></a>
      <b-collapse id="nav-collapse" is-nav>
        <!-- <b-navbar-nav class="ml-auto">
          <b-dropdown v-b-tooltip.hover title="Status" variant="outline-light" :text="statusFilter" size="sm" class="m-2" :disabled="!filteredFeatureList.length" right>
            <b-dropdown-item-button v-on:click="statusFilterChange('Status')">All</b-dropdown-item-button>
            <b-dropdown-item-button v-for="(item, index) in statusFilterSet" :key="index" v-on:click="statusFilterChange(item)">{{item}}</b-dropdown-item-button>
          </b-dropdown>
          <b-dropdown v-b-tooltip.hover title="Discipline" variant="outline-light" :text="disciplineFilter" size="sm" class="m-2" :disabled="!filteredFeatureList.length" right>
            <b-dropdown-item-button v-on:click="disciplineFilterChange('Discipline')">All</b-dropdown-item-button>
            <b-dropdown-item-button v-for="(item, index) in disciplineFilterSet" :key="index" v-on:click="disciplineFilterChange(item)">{{item}}</b-dropdown-item-button>
          </b-dropdown>
        </b-navbar-nav> -->
      </b-collapse>
    </b-navbar>
    <div class="row">
      <div class="col list-group">
        <template v-if="filteredFeatureList.length">
            <a href="#" v-for="item in filteredFeatureList" :key="item.objectId" class="list-group-item list-group-item-action" v-on:click="selectSensorFromList(item.objectId)">
              <div class="row">
                <div class="col-1 ml-3">
                  <i class="fa fa-tv"></i>
                </div>
                <div class="col-10">
                  <div class="d-flex w-100 justify-content-between">
                    <p style="margin-bottom: 0.25rem;"><span class="badge badge-secondary badge-pill badge-custom">{{item.objectId}}</span><small> {{item.sensorCode}}</small></p>
                    <p style="margin-bottom: 0.25rem;">
                      <template v-if="item.status == '0'">
                        <!-- <span class="badge badge-success badge-pill">{{item.status}}</span> -->
                        <span class="badge badge-success badge-pill">Available</span>
                      </template>
                      <template v-else>
                        <!-- <span class="badge badge-danger badge-pill">{{item.status}}</span> -->
                        <span class="badge badge-danger badge-pill">Occupied</span>
                      </template>
                    </p>
                  </div>
                  <!-- <div class="d-flex w-100 justify-content-between">
                    <p class="mb-0 font-weight-normal">
                      <small>"{{item.comment.length > 20 ? item.comment.substring(0, 30) + '...' : item.comment}}"</small>
                    </p>
                    <p style="margin-bottom: 0.25rem;">
                      <small class="text-muted">{{item.discipline}}</small>&nbsp;&nbsp;
                      <template v-if="item.approvalStatus == 'Approved'">
                        <span class="badge badge-success badge-pill">{{item.approvalStatus}}</span>
                      </template>
                      <template v-else>
                        <span class="badge badge-danger badge-pill">{{item.approvalStatus}}</span>
                      </template>
                    </p>
                  </div> -->

                </div>
              </div>
            </a>
          <!-- </div> -->

        </template>
        <template v-else>
          <li class="list-group-item">Loading&hellip;</li>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
/*eslint-disable*/
import { loadModules } from 'esri-loader';
import {baseApiUrl} from "../../config.js"
import axios from "axios"

export default {
  name: 'SideMenu',
  data () {
    return {
      selectedDiscipline: "",
      view: null,
      // commentReplyList: this.$store.state.mapModule.commentReplies,
      sensorIds: [],
      sensorSceneLayer: null,
      highlight: null,
      // disciplineFilterSet: ['Road Design','Bridge','Utility','Drainage','Environment','Ecology','Heritage','Geotechnical'],
      // disciplineFilter: "Discipline",
      // statusFilterSet: ['Approved','Pending'],
      // statusFilter: "Status",
      statusFilterCounter: 0,
      intervalTime: 1000*120,
      pollingInterval: {},
    }
  },
  computed: {
    webscene: {
      get() {
        return this.$store.state.mapModule.mapWebScene
      }
    },
    currentSensorId: {
      get() {
        return this.$store.state.mapModule.currentSensorId
      }
    },
    sensorFeatureList: {
      get() {
        return this.$store.state.mapModule.initialSensors
      }
    },
    filteredFeatureList: {
      get() {
        var finalList = this.sensorFeatureList
        // if (this.disciplineFilter == "Discipline") {
        //   finalList =  this.sensorFeatureList
        // }
        // else {
        //   finalList = this.sensorFeatureList.filter(obj=>obj.discipline == this.disciplineFilter)
        // }
        // if (this.statusFilter != "Status") {
        //   finalList = finalList.filter(obj=>obj.approvalStatus == this.statusFilter)
        // }
        return finalList
      }
    }
  },
  watch: {
    webscene: function() {
      const current = this
      console.log("webscene watch1");

      if (current.webscene) {
        console.log("webscene watch2");
        current.loadCommentList()
        current.pollingInterval = setInterval(current.loadCommentList, current.intervalTime)
      }
    },
    sensorFeatureList: function() {
      const current = this
      if (current.sensorFeatureList) {
        console.log(window.location.href.split("/"));
        var objectId = window.location.href.split("/")[window.location.href.split("/").length - 1]
        if (!isNaN(parseInt(objectId))) {
          current.selectSensorFromList(objectId)
        }
      }
    }
  },
  methods: {
    loadCommentList: function() {
      const current = this
      var appMap = document.getElementById("map");
      var sceneView = appMap.__vue__.view;
      console.log(current.webscene.allLayers);
      current.sensorSceneLayer = current.webscene.allLayers.filter(function(item) {
        return item.title === "SensorPoints V2";
        // return item.title === "Comments3DDevelopment";
      }).items[0];

      current.sensorSceneLayer.outFields = ["objectid"];
      // console.log(current.sensorSceneLayer.getFieldUsageInfo('OBJECTID'));
      const queryParams = current.sensorSceneLayer.createQuery()

      queryParams.orderByFields = ["objectid"]
      console.log(queryParams);
      current.sensorSceneLayer.queryFeatures(queryParams).then((featureResultItems) => {
        console.log(featureResultItems);
        current.sensorIds = []
        current.$store.commit("mapModule/resetInitialSensors")
        featureResultItems.features.forEach(item => {
          console.log(item.attributes);
          var featureObject = {}

          // featureObject["objectId"] = item.attributes.OBJECTID
          featureObject["objectId"] = item.attributes.objectid
          featureObject["sensorCode"] = item.attributes.sensor_code
          current.getSensorDataStatus(item.attributes.sensor_code).then(dataStatusResult => {
            featureObject["status"] = dataStatusResult
            item.attributes.status = dataStatusResult
            current.sensorIds.push(item.attributes.OBJECTID)

            var edits = {
              updateFeatures: [item]
            }
            current.$store.commit("mapModule/insertInitialSensors", featureObject)

            current.sensorSceneLayer.applyEdits(edits).then((result)=> {
              console.log("edits successfully applied");
              sceneView.map.allLayers.remove(current.sensorSceneLayer);
              sceneView.map.allLayers.add(current.sensorSceneLayer);
            }).catch((error)=> {
              console.log(error);
            })

            console.log(dataStatusResult);
          })

          // featureObject["status"] = current.getSensorDataStatus(item.attributes.sensor_code)

          console.log("test fetch status");
          console.log(featureObject);




        })
        // current.$store.dispatch("mapModule/fetchCommentReplies", {objectIds: current.sensorIds})
      })

    },
    selectSensorFromList:function(commentId) {
      console.log(commentId);
      const current = this
      if (!current.sensorSceneLayer) {
        current.sensorSceneLayer = current.webscene.allLayers.filter(function(item) {
          return item.title === "SensorPoints V2";
          // return item.title === "Comments3DDevelopment";
        }).items[0];
      }
      if (current.currentSensorId == commentId) {
        // current.$store.commit("mapModule/clearAttachments")
        current.toggleFlexContainer()
      }
      else {
        console.log(current.currentSensorId);
        current.closeFlexContainer()
        // current.$store.commit("mapModule/clearAttachments")
        current.$store.dispatch("mapModule/setCurrentCommentDetails", commentId)
        console.log(current.currentSensorId);
        current.openFlexContainer()
        const vue = document.getElementById("map").__vue__
        const view = vue.view
        console.log(vue);
        console.log(view);
        loadModules(["esri/tasks/support/Query", "esri/identity/IdentityManager"],{ css: true })
        .then(([Query, esriId]) => {
          current.$store.commit("mapModule/saveUserName", esriId.credentials[0].userId)
          console.log(current.sensorSceneLayer);
          view.whenLayerView(current.sensorSceneLayer).then(function(commentLayerView){
            var queryExtent = new Query({
              objectIds: [commentId],
              returnZ: true,
              returnGeometry: true
            });

            current.sensorSceneLayer.queryFeatures(queryExtent)
            .then(function(result) {
              console.log(result);
              if (result.features.length == 1) {
                var center = result.features[0].geometry
                var tilt = view.camera.tilt
                // console.log(result.extent.center);
                // console.log(result);
                // console.log(result.center);
                console.log(center);
                view.goTo({
                  speedFactor: 0.5,
                  zoom: 19,
                  tilt: tilt,
                  center: center
                });
              }
              else {
                current.closeFlexContainer()
              }
            });
            if (current.highlight) {
              current.highlight.remove();
            }
            current.highlight = commentLayerView.highlight([commentId]);
          })



        })

      }
    },
    clearTextData:()=>{
      var reply = document.getElementById("newReplyTextArea")
      if (reply) {
        reply.innerHTML = ""
        reply.value = ""
      }
    },
    toggleFlexContainer: function() {
      this.clearTextData()
      var flexContainer = document.getElementById("flexContainer")
      var map = document.getElementById("mapContainer")
      map.classList.toggle("col-9")
      flexContainer.classList.toggle("displayNone")
      map.classList.toggle("col-6")
    },
    closeFlexContainer: function() {
      this.clearTextData()
      var flexContainer = document.getElementById("flexContainer")
      var map = document.getElementById("mapContainer")
      flexContainer.classList.add("displayNone")
      map.classList.remove("col-6")
      map.classList.add("col-9")
    },
    openFlexContainer: function() {
      var flexContainer = document.getElementById("flexContainer")
      var map = document.getElementById("mapContainer")
      map.classList.remove("col-9")
      map.classList.add("col-6")
      flexContainer.classList.remove("displayNone")
    },
    disciplineFilterChange: function(selection) {
      this.disciplineFilter = selection
    },
    statusFilterChange: function(selection) {
      this.statusFilter = selection
    },
    getFormattedDate: function(dateItem) {
      let date = new Date(dateItem)
      let year = date.getFullYear().toString();
      let month = date.getMonth() + 1;
      month = month.toString().padStart(2, '0');
      let day = date.getDate().toString().padStart(2, '0');
      let hours = date.getHours() > 12 ? date.getHours() - 12 : date.getHours();
      let am_pm = date.getHours() >= 12 ? "pm" : "am";
      hours = hours < 10 ? "0" + hours : hours;
      let minutes = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      let time = hours + ":" + minutes + " " + am_pm;
      return year + '-' + month + '-' + day + " " + time;
    },
    getSensorDataStatus: function(sensorCode) {
      const current = this;
      return new Promise(function(resolve, reject) {
        var url = baseApiUrl + "sensorDataStatus"
        var config = {
          responseType: 'json',
          params: {
            sensorId: sensorCode
          }
        }
        axios.get(url, config).then(function(result) {
          console.log("result log");
          console.log(result.data);
          var statusResult = result.data
          // return statusResult
          resolve(statusResult)
        }).catch((error)=> {
          reject(error);
        });
      })

    }
  },
}
</script>

<style>
  .panel-result {
    cursor: pointer;
    margin: 2px 0;
  }

  .panel-result:hover,
  .panel-result:focus,
  .panel-result.selected {
    background-color: rgba(200, 200, 200, 0.6);
  }
  .tailor {
    height: 93vh;
    max-height: 99%;
    overflow-y: scroll;
    overflow-x: hidden;
  }

  .badge-custom {
    padding-right: 0.45em !important;
    padding-left: 0.45em !important;
    padding: 0.45em 0.45em !important;
  }

</style>
